var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('BaseSectionHeader',{staticClass:"border-t pt-4 border-strong-shadow-color mb-4"},[_vm._v("\n    "+_vm._s(_vm.$t('Timeline'))+"\n  ")]),_c('BaseTimeline',{staticClass:"pl-2 mb-8",attrs:{"timeline":_vm.timeline}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }